import React, { useEffect, useContext, useState } from "react";
import { environmentVariables } from "../../config/env.config";
import { userContext } from "../../context/userContext";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import successright from '../../Images/check.png'
import {useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import axios from "axios"; 
import { toast } from "react-toastify";

const TotalPaypaymentRestaurant = () => {
   const { t } = useTranslation();
  const [paymentData, setPaymentData] = useState(null);
  const [isVerifying, setIsVerifying] = useState(true);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [cURLTORedirect, setCURLTORedirect] = useState('');
  const [orderID, setOrderID] = useState("NA");
  const navigate = useNavigate();
  const { search } = location;
  const urlParams = new URLSearchParams(window.location.search);




  

  const handleRedirect = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const transactionToken = urlParams.get('TransactionToken');
    const companyRef = urlParams.get('CompanyRef');
    const status = urlParams.get('status');
    setOrderID(transactionToken)
    const cURL = urlParams.get('cURL');
    setCURLTORedirect(cURL)
    
    if (transactionToken && companyRef) {
      try {
        const verifyResponse = await fetch(`${environmentVariables?.apiUrl}api/v1/restaurant/VerifyTokenRestaurantTotalPay`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            transaction_token: transactionToken,
            status: status,
          }),
        })
        const responseData = !!verifyResponse? await verifyResponse.json():'';  
        setPaymentData(responseData?.data);       
        if(responseData?.success == true){
          setPaymentPopUp(true);
          setPaymentSuccess(true);
          axios.delete(`${environmentVariables?.apiUrl}api/v1/cart/deleteCartByUserId?customerOrderId=${customerOrderId}&type=restaurantmenu`)
          setIsVerifying(false);
          setTimeout(() => {
            window.location.href=cURL;
          }, 3000);
          return;
        }else{
          toast.error("Error verifying payment order.");
          setIsVerifying(false);
          setPaymentPopUp(true); 
          setPaymentSuccess(false);
          setTimeout(() => {
            window.location.href=cURL;
          }, 3000);
        }
    
      } catch (error) {

        setIsVerifying(false);
        setPaymentPopUp(false);
        setPaymentSuccess(false);
        setTimeout(() => {
          window.location.href=cURL;
        }, 3000);
        console.error('Error verifying payment order:', error);
      } finally {
        setIsVerifying(false);
       
        toast.error("Error verifying payment order.");
      }
    } else {
      setIsVerifying(false);
      setPaymentPopUp(false);
      setPaymentSuccess(false);
      
      toast.error("TransactionToken or CompanyRef not found in URL.");
    }
  };
  useEffect(() => {
    handleRedirect();
  }, []);

  const customerOrderId = urlParams.get('order_id');

  return (
    <>
    {isVerifying ? (
      <div className="loader-container-dpo">
        <CircularLoader />
        <h4>{t("Processing_order")}</h4>
        <p>{t("Thank_for_order")}</p>
      </div>
    ) : (
      <form>
        {paymentSuccess ? (
          <div className="loader-container-dpo">
          <h4>{t("Payment_verified")}</h4>
        </div>
        ) : (
          <div className="loader-container-dpo">
          <h4>{t("Something_went_wrong")}</h4>
        </div>
        )}
      </form>
    )}
    {paymentPopUp && (
      <div className="popup-outer">
        <div className="popup-overlay"></div>
        <div className="popup-inner">
          <div className="fs-1 payment_heaader">
            {paymentSuccess ? <span className="text-success">{"Payment Successful"}</span> : <span className="text-danger">{"Payment Failed"}</span>}
          </div>
          {paymentSuccess ? <img loading="lazy" src={successright} className="" />:""}
          <div className="inner-box mt-4">
            <h1 className="name">{t("Payment_details")}</h1>
            <div className="orderbox">
              <ul className="list-group mb-3">
                <li className="list-group-item d-flex justify-content-between">
                  <span>{t("Receiver")}</span>
                  <strong>{t("Businessbay")}</strong>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>{t("Payment_method_type")}</span>
                  <strong>{paymentData?.payment_method}</strong>
                </li>

                <li className="list-group-item d-flex justify-content-between">
                  <span> {t("Amount_paid")}</span>
                  <strong>{'AED'} {paymentData?.totalAmount}</strong>
                </li>

                <li className="list-group-item d-flex justify-content-between">
                  <span>{t("Transaction_id")}</span>
                  <strong>{orderID}</strong>
                </li>
              </ul>
            </div>
            <div className="order-box">
            </div>
          </div>
        </div>
      </div>
    )}
  </>
  );
};

export default TotalPaypaymentRestaurant;
